import { AspectContainer } from '../../AspectContainer';
import { BuildingViewerFloorData } from '../../../../Content';
import { PickableRegion } from './PickableRegion';

export interface Props {
  src: string;
  floors: BuildingViewerFloorData[];
  activeFloor: BuildingViewerFloorData | null;
  onFloorClick: (floor: BuildingViewerFloorData) => void;
}

export const FloorPicker: React.FC<Props> = (props) => {
  return (
    <AspectContainer aspect={0.5625}>
      <div
        style={{
          backgroundImage: `url("${props.src}")`,
          backgroundSize: 'cover',
          height: '100%',
          position: 'relative',
        }}
      >
        {/* Floor Region */}
        {props.floors.map((floor) => (
          <PickableRegion
            key={floor.id}
            region={floor.region}
            isActive={floor === props.activeFloor}
            onClick={() => props.onFloorClick(floor)}
          />
        ))}
      </div>
    </AspectContainer>
  );
};
